<template>
  <div>
    <wc-data-box
      :title='basics.title'
      :titleIcon='basics.icon'
      :titleIconColor='basics.iconColor'
      :showEdit='!project.archived'
      @edit='editProject'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='basics.title'
      :icon='basics.icon'
      :iconColor='basics.iconColor'
      @cancel='showDialog = false'
      @save='saveProject'
      :disableButtons='!isFormValid'
      width='400'
    >
      <template v-slot:dialog-actions v-if='project.division_obj.division !== "Construction"'>
        <v-tooltip open-delay='700' top>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn icon class='ml-2 mt-n2' :disabled='disableMapping' @click='mapAddress'>
                <v-icon large color='grey darken-1'>mdi-map-marker</v-icon>
              </v-btn>
            </div>
          </template>
          <span>{{mappingTooltip}}</span>
        </v-tooltip>
      </template>
      <v-form v-model='isFormValid'>
        <basics-form
          v-model='projectCopy'
          @useOwnerAddress='useOwnerAddress'
        ></basics-form>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import BasicsForm from '@/modules/projects/components/forms/BasicsForm'

export default {
  name: 'snow-basics',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    projectCopy: {}
  }),
  computed: {
    estimateRoute () {
      let ret = null
      if (this.project.division_obj) {
        switch (this.project.division_obj.division_type) {
          case 'S':
            ret = 'SnowEstimate'
            break
          case 'I':
            ret = 'IrrigationEstimate'
            break
          case 'L':
            ret = 'LawnEstimate'
            break
        }
      }
      return ret
    },
    items () {
      let dt = [
        { text: 'Project Name', value: this.project.name },
        { text: 'Project Number', value: this.project.number },
        { text: 'Site address', value: this.project.site_address },
        { text: 'Site city', value: this.project.site_city },
        { text: 'Site province', value: this.project.site_province },
        { text: 'Site postal code', value: this.project.site_postal_code }
      ]
      if (this.project.division_obj.division !== "Construction") {
        dt.push({ text: 'Latitude', value: this.project.lat })
        dt.push({ text: 'Longitude', value: this.project.lng })
        dt.push({ text: 'Route Position', value: this.project.route_group + (this.project.route_number ? this.project.route_number : "") })
      }
      return dt
    },
    ...mapState({
      basics: state => state.icons.dataBox.basics
    }),
    disableMapping() {
      if (!this.project.site_address || !this.project.site_city) {
        return true
      }
      return false
    },
    mappingTooltip() {
      if (!this.project.site_address || !this.project.site_city) {
        return 'Address and City are required for mapping'
      }
      return 'Map this address (opens in new window)'
    }
  },
  methods: {
    editProject () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    saveProject () {
      if (this.projectCopy.route_number === "") {
        this.projectCopy.route_number = null
      }
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    },
    useOwnerAddress () {
      this.projectCopy.site_address = this.projectCopy.owner_obj.address
      this.projectCopy.site_city = this.projectCopy.owner_obj.city
      this.projectCopy.site_province = this.projectCopy.owner_obj.province
      this.projectCopy.site_country = this.projectCopy.owner_obj.country
      this.projectCopy.site_postal_code = this.projectCopy.owner_obj.postal
    },
     mapAddress () {
      let URL = "https://www.google.com/maps/place/" + this.project.site_address + '+' + this.project.site_city
      window.open(URL, '_blank', )
    },
  },
  components: {
    'basics-form': BasicsForm
  }
}
</script>
